/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_Agent_Native_PositioningInputs */

const en_directory_agent_readiness_check_agent_native_positioning = /** @type {(inputs: Directory_Agent_Readiness_Check_Agent_Native_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent-native positioning`)
};

const zh_directory_agent_readiness_check_agent_native_positioning = /** @type {(inputs: Directory_Agent_Readiness_Check_Agent_Native_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`智能体原生定位`)
};

/**
* | output |
* | --- |
* | "Agent-native positioning" |
*
* @param {Directory_Agent_Readiness_Check_Agent_Native_PositioningInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_agent_native_positioning = /** @type {((inputs?: Directory_Agent_Readiness_Check_Agent_Native_PositioningInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_Agent_Native_PositioningInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_agent_native_positioning(inputs)
	return zh_directory_agent_readiness_check_agent_native_positioning(inputs)
});
export { directory_agent_readiness_check_agent_native_positioning as "directory.agent_readiness.check.agent_native_positioning" }